export const SET_SUPPORTED_BROWSER_FLAG = 'SET_SUPPORTED_BROWSER_FLAG' as const;

export const setSupportedBrowserFlag = (isSupportedBrowser: boolean) => ({
  type: SET_SUPPORTED_BROWSER_FLAG,
  payload: isSupportedBrowser,
});
